module.exports = "https://static.im-cdn.com/mjc/storefront/Esteem/static/media/FooterInstagram.4c291bff.svg";